import {AzureB2CCredentials} from "orpyx-web-common";

export const adminAzureB2cCredentials = new AzureB2CCredentials
(
    process.env.REACT_APP_B2C_CLIENT_ID!,
    process.env.REACT_APP_B2C_TENANT_NAME!,
    process.env.REACT_APP_B2C_POLICIES!,
    process.env.REACT_APP_B2C_SCOPE_NAME!,
);
